export enum FaxDirection {
  Inbound = "Inbound",
  Outbound = "Outbound",
}
